module.exports = __webpack_public_path__ + "img/20190702161016871.1cf13c79.png";